// extracted by mini-css-extract-plugin
export default {"component":"Button_component__QTUHg","contained":"Button_contained__ueupA","outlined":"Button_outlined__-tAZi","clear":"Button_clear__7GWUr"};